<template>
   <div :class="col">
      <div class="mb-0 position-relative sa-field" :class="{ 'text-end': align === 'end' }">
         <label v-if="label" class="form-label d-block">{{ label }}</label>

         <!-- custom-tooltip-input: the tooltip script shows the tooltip for the whole group -->
         <div class="btn-group custom-tooltip-input" role="group" :aria-label="label || groupName">
            <template v-for="(option, index) in options" :key="option.value">
               <input
                  v-bind="$attrs"
                  type="radio"
                  class="btn-check"
                  :name="groupName"
                  :id="groupName + '-' + index"
                  :value="option.value"
                  :checked="modelValue === option.value"
                  autocomplete="off"
                  @change="$emit('update:modelValue', option.value)"
               />
               <label class="btn btn-outline-primary" :for="groupName + '-' + index">{{ option.label }}</label>
            </template>
         </div>

         <!-- Above the buttons: on focus, and in red while nothing is chosen (required) -->
         <div v-if="tooltip" class="custom-tooltip">{{ tooltip }}<span class="tooltip-arrow"></span></div>
      </div>
   </div>
</template>

<script>
// A row of buttons where one can be chosen (radio buttons).
//   <RadioField v-model="formInputs.radio1" col="col-md-6" label="Fancy Radio Buttons" name="radioGroup"
//               :options="[{ label: 'Male', value: 'male' }, { label: 'Female', value: 'female' }]"
//               tooltip="Please choose Male or Female" align="end" required />
// name must be unique on the page ($validateForm finds the group by its name).
// required, @change ... go to every radio input.
let nextId = 0;

export default {
   name: "RadioField",
   inheritAttrs: false,
   props: {
      modelValue: { default: "" },
      options: { type: Array, default: () => [] }, // [{ label, value }]
      label: { type: String, default: "" },
      name: { type: String, default: "" },
      tooltip: { type: String, default: "" },
      col: { type: String, default: "col-md-6" },
      align: { type: String, default: "start" },   // "end" = to the far right
   },
   emits: ["update:modelValue"],
   data() {
      return { autoName: "radio-field-" + ++nextId };
   },
   computed: {
      groupName() {
         return this.name || this.autoName;
      },
   },
};
</script>